import request from '@/services/interceptor.js'


// GET - Recupera tutte le info del profilo (utente + azienda + apiKey)
export const get_dati_utente = () => {
    return request({
        url: '/profilo/info',
        method: 'get',
        loadingBar: true
    })
}

// PUT - Aggiorna username ed email dell'utente
export const aggiorna_dati_utente = (data) => {
    return request({
        url: '/profilo/utente',
        method: 'put',
        data,
        loadingBar: true
    })
}

// PUT - Cambia password
export const cambia_password = (data) => {
    return request({
        url: '/profilo/password',
        method: 'put',
        data,
        loadingBar: true
    })
}

// POST - Rigenera API Key
export const rigenera_api_key = () => {
    return request({
        url: '/profilo/apikey/rigenera',
        method: 'post',
        loadingBar: true
    })
}

// PUT - Abilita o disabilita API Key  ({ attivo: true/false })
export const toggle_api_key = (attivo) => {
    return request({
        url: '/profilo/apikey/toggle',
        method: 'put',
        params: { attivo },
        loadingBar: true
    })
}

// ── Personalizzazione export PDF (solo admin/super-admin) ─────────────────

// GET - Recupera la configurazione PDF dell'azienda
export const get_pdf_config = () => {
    return request({
        url: '/profilo/pdf-config',
        method: 'get',
        loadingBar: true
    })
}

// PUT - Aggiorna template/colore/intestazione/piè di pagina (solo piano Pro)
export const aggiorna_pdf_config = (data) => {
    return request({
        url: '/profilo/pdf-config',
        method: 'put',
        data,
        loadingBar: true
    })
}

// POST - Carica il logo aziendale per i PDF (solo piano Pro)
export const carica_logo_pdf = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: '/profilo/pdf-logo',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}

// DELETE - Rimuove il logo aziendale
export const rimuovi_logo_pdf = () => {
    return request({
        url: '/profilo/pdf-logo',
        method: 'delete',
        loadingBar: true
    })
}

// GET - Recupera l'immagine del logo già caricato (per l'anteprima)
export const get_logo_pdf = () => {
    return request({
        url: '/profilo/pdf-logo',
        method: 'get',
        responseType: 'blob',
        loadingBar: false
    })
}